import { Platform, StyleSheet } from 'react-native';
import { MD3Theme } from 'react-native-paper';

import { spacing, window } from '../../theme/tokens';

const styles = (theme: MD3Theme) => {
  return StyleSheet.create({
    closeButton: { margin: 0 },
    container: {
      justifyContent: 'flex-end',
      margin: 0,
    },
    content: {
      backgroundColor: theme.colors.background,
      borderTopLeftRadius: spacing.medium,
      borderTopRightRadius: spacing.medium,
      maxHeight: '95%',
      ...(Platform.OS === 'web' ? { alignSelf: 'center', width: window.width / 3 } : undefined),
    },
    header: {
      alignItems: 'flex-end',
    },
    innerContainer: { paddingBottom: spacing.large, paddingHorizontal: spacing.medium },
  });
};

export default styles;
